import React from 'react';

import { SafeHtmlRenderer } from 'js/utils/components/SafeHtmlRenderer';

function processHtmlString(str: string): string {
  str = '...' + str + '...';
  str = str.replace(/↵/g, '&nbsp;');
  return str;
}

type WorkSnippetProps = {
  htmlString?: string;
};

export const WorkSnippet: React.FC<WorkSnippetProps> = ({ htmlString }) => {
  if (!htmlString) return null;

  return (
    <SafeHtmlRenderer
      className="wp-workCard_item wp-workCard--snippet"
      html={processHtmlString(htmlString)}
    />
  );
};

type UserCitationSnippetProps = {
  title: string;
  url?: string;
};

export const UserCitationSnippet: React.FC<UserCitationSnippetProps> = ({
  title,
  url,
}) => {
  return (
    <div className="wp-workCard_item wp-workCard--snippet">
      <div className="wp-workCard--snippet--title">
        {url ? <a href={url}>{title}</a> : title}
      </div>
    </div>
  );
};
